import { useMutation } from 'react-query'

import { fetchInvoiceDownloadData } from '../query-api'

export const useFetchInvoiceDownloadData = () => {
  const { mutate: fetch, isLoading: isProcessing, ...rest } = useMutation(fetchInvoiceDownloadData)

  return { fetch, isProcessing, ...rest }
}
